import { CheckBox } from 'entities/ChekBox'
import { DefaultBranchIdContainer } from './styles'
import { RenderIf } from 'shared/helpers/renderIf'
import { useGlobalStore } from 'shared/store/globalSlice'
import { usePaymentConfigStore } from 'shared/store/paymentSlice'
import { useBranchStore } from 'shared/store/branchesSlice'
import { useEffect } from 'react'

export const DefaultBranchId = () => {
  const isCC = useGlobalStore().isCCSelected
  const branchId = useBranchStore().branchId
  const isConfigLoaded = usePaymentConfigStore().isConfigLoaded
  const updateCCConfig = usePaymentConfigStore().updateCCConfig
  const defaultBranchId = usePaymentConfigStore().clickCollectConfig.defaultBranchId

  useEffect(() => {
    if (!defaultBranchId && isConfigLoaded) {
      updateDefaultBranch()
    }
  }, [defaultBranchId, isConfigLoaded])

  const updateDefaultBranch = () => {
    if (defaultBranchId !== branchId) {
      updateCCConfig({ defaultBranchId: branchId })
    }
  }

  return (
    <DefaultBranchIdContainer>
      <RenderIf condition={isCC}>
        <CheckBox
          label='Select branch by default'
          handleChange={updateDefaultBranch}
          checked={defaultBranchId === branchId}
        />
      </RenderIf>
    </DefaultBranchIdContainer>
  )
}
